module.exports = __webpack_public_path__ + "img/zim.6ac3949a.svg";